<template>
  <div class="task-box" v-for="(allitem,indexall) in allArr" :key="indexall">
    <div :class="allitem.length<3?'task-msg2':'task-msg'" v-for="(item, index) in allitem" :key="index">
      <p>{{ item.title }}</p>
      <a-tooltip placement="top">
        <template #title>
          <span
            >{{ item.firstData }}<span>/{{ item.secondData }}</span></span
          >
        </template>
        <span class="overspan"
          >{{ item.firstData }}<span>/{{ item.secondData }}</span></span
        >
      </a-tooltip>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType, toRefs, watch, ref } from 'vue'

interface TaskData {
  title: string
  firstData: string | number
  secondData: string | number
}
export default defineComponent({
  props: {
    option: {
      type: Array as PropType<TaskData[]>,
      default: () => []
    }
  },
  setup(props) {
    const opt = toRefs(props).option
    const arrSplice = (arr:any) => {
      const arrLength = arr.length // 数组长度
      const num = 5 // 每页显示 10 条
      let index = 0
      const newArr = []

      for (let i = 0; i < arrLength; i++) {
        if (i % num === 0 && i !== 0) { // 可以被 10 整除
          newArr.push(arr.slice(index, i))
          index = i
        }
        if ((i + 1) === arrLength) {
          newArr.push(arr.slice(index, (i + 1)))
        }
      }
      return newArr
      // console.log('newArr66666666: ', newArr)
    }
    const allArr:any = ref([])
    watch(() => props.option, () => {
      if (props.option.length > 5) {
        allArr.value = arrSplice(opt.value)
      } else {
        allArr.value = [opt.value]
      }
    })

    return { opt, allArr }
  }
})
</script>
<style lang="scss" scoped>
.overspan {
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
  // width: 150px;
  text-align: center;
  cursor:pointer
}
.task-box {
  // width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 30px;
  .task-msg {
    // width: 20%;
    height: 113px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    p {
      font-weight: 400;
      font-size: 12px;
      display: block;
      margin-bottom: 10px;
      color: #999999;
    }
    span {
      font-weight: 700;
      font-size: 20px;
      color: #333333;
      span {
        font-weight: 400;
        font-size: 14px;
        color: #999999;
      }
    }
  }
  .task-msg2{
width: 50%;
    height: 113px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    p {
      font-weight: 400;
      font-size: 12px;
      display: block;
      margin-bottom: 10px;
      color: #999999;
    }
    span {
      font-weight: 700;
      font-size: 20px;
      color: #333333;
      span {
        font-weight: 400;
        font-size: 14px;
        color: #999999;
      }
    }
  }
}
</style>
